module.exports = __webpack_public_path__ + "static/img/hover-iocn0.6b490e1.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/add_icon/hover-iocn0.svg
// module id = Usgr
// module chunks = 3